import { t } from "i18next";
import * as Yup from 'yup';

export function getCPEValidationScheme(withHostingSite = false, invalidSdnV4Ids: string[] = []) {
  return Yup.object().shape({
    hosting_site: withHostingSite ? Yup.object().required(t('Required')) : Yup.object(),
    sdn_v4_id: Yup.string().nullable().matches(/^[a-z0-9]*$/, t("Lowercase and numbers"))
      .test("sdn_v4_id_length", t("must be exactly 0 or 8 characters"), value => value == undefined || value.length === 0 || value.length === 8)
      .test("sdn uniqueness", t("Already in hosting site"), (id) => id == null || id == undefined || !invalidSdnV4Ids.includes(id)),
    theft_mark: Yup.string().max(50).nullable(),
    vlan_names: Yup.array().max(10).of(Yup.string().max(15).nullable().matches(/^[a-zA-Z0-9_-]*$/, t("Vlan format")))
  });
}